// extracted by mini-css-extract-plugin
module.exports = {"button":"_808f12","highlightText":"_2da4e0","container":"_136b04","text":"_311101","hiddenText":"_ea4659","ellipsis":"_26d21c"};